
import React, { useState } from "react";

import { PostDataAPI } from "../services/PostDataAPI";

import SuccessErrorDialog from "./successErrorDialog";

import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ReviewForm = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        phone: "",
        email: "",
        injuryType: "",
        briefDescription: "",
        privacyPolicy: false,
        termsConditions: false
    });

    const initialFormValues = {
        fullName: "",
        phone: "",
        email: "",
        injuryType: "",
        briefDescription: "",
        privacyPolicy: false,
        termsConditions: false
    };

    const handleReset = () => {
        setFormData(initialFormValues);
        setErrors({});
    };

    const [message, setMessage] = useState(null);
    const [type, setType] = useState(null);
    const [submitLoader, setSubmitLoader] = useState(false);
    const [resultDialog, setResultDialog] = useState(false);

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const formatPhoneNumber = (value) => {
        const phone = value.replace(/\D/g, "").substring(0, 10);
        const size = phone.length;

        if (size < 4) return phone;

        if (size < 7) {
            return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
        }

        return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : name === "phone"
                        ? formatPhoneNumber(value)
                        : value
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: ""
        }));
    };

    const validate = () => {
        const newErrors = {};

        if (!formData.fullName.trim()) {
            newErrors.fullName = "Full name is required.";
        }

        if (!formData.phone.trim()) {
            newErrors.phone = "Contact number is required.";
        } else if (
            !/^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(formData.phone)
        ) {
            newErrors.phone = "Enter a valid phone number.";
        }

        if (!formData.email.trim()) {
            newErrors.email = "Email is required.";
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
        ) {
            newErrors.email = "Enter a valid email.";
        }

        if (!formData.injuryType) {
            newErrors.injuryType = "Please select an injury type.";
        }

        if (!formData.briefDescription.trim()) {
            newErrors.description = "Please enter a brief description.";
        }

        // Privacy Policy validation
        if (!formData.privacyPolicy) {
            newErrors.privacyPolicy =
                "Please agree to the Privacy Policy.";
        }

        // Terms & Conditions validation
        if (!formData.termsConditions) {
            newErrors.termsConditions =
                "Please agree to the Terms and Conditions.";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) {
            return;
        }

        setSubmitLoader(true);
        setErrors({});

        const formValues = { ...formData };

        try {
            setLoading(true);

            const result = await PostDataAPI(
                "confidentailRequest/add",
                formValues
            );

            if (result.success) {
                setMessage(
                    "Your request has been received. Thank you for reaching out. We will review your submission and get in touch with you shortly."
                );

                setType("success");
                setSubmitLoader(false);

                setTimeout(() => {
                    setResultDialog(true);
                    handleReset();
                }, 100);
            } else {
                setSubmitLoader(false);

                setMessage(
                    result.message || "Failed to submit request."
                );

                setType("error");
                setResultDialog(true);
            }
        } catch (error) {
            setSubmitLoader(false);

            setMessage("Failed to submit request.");

            setType("error");
            setResultDialog(true);
        } finally {
            setLoading(false);
            setSubmitLoader(false);
        }
    };

    return (
        <>
            <div className="hero-card">

                <div className="hero-card-label">
                    Confidential
                </div>

                <h3>
                    Request a Confidential Case Review
                </h3>

                <p>
                    No upfront legal fees. Direct attorney attention.
                </p>

                <form onSubmit={handleSubmit}>

                    {/* Full Name */}
                    <div className="form-group">
                        <label>Full Name</label>

                        <input
                            type="text"
                            name="fullName"
                            placeholder="Your full name"
                            value={formData.fullName}
                            onChange={handleChange}
                        />

                        {errors.fullName && (
                            <small className="error">
                                {errors.fullName}
                            </small>
                        )}
                    </div>


                    {/* Contact Number */}
                    <div className="form-group">
                        <label>Contact Number</label>

                        <input
                            type="tel"
                            name="phone"
                            placeholder="(XXX) XXX-XXXX"
                            value={formData.phone}
                            onChange={handleChange}
                        />

                        {errors.phone && (
                            <small className="error">
                                {errors.phone}
                            </small>
                        )}
                    </div>


                    {/* Email Address */}
                    <div className="form-group">
                        <label>Email Address</label>

                        <input
                            type="email"
                            name="email"
                            placeholder="your@email.com"
                            value={formData.email}
                            onChange={handleChange}
                        />

                        {errors.email && (
                            <small className="error">
                                {errors.email}
                            </small>
                        )}
                    </div>


                    {/* Injury Type */}
                    <div className="form-group">
                        <label>Select Injury Type</label>

                        <select
                            name="injuryType"
                            value={formData.injuryType}
                            onChange={handleChange}
                        >
                            <option value="">
                                Choose one…
                            </option>

                            <option value="Personal Injury">
                                Personal Injury
                            </option>

                            <option value="Rear-End Collision">
                                Rear-End Collision
                            </option>

                            <option value="Car Accidents">
                                Car Accidents
                            </option>

                            <option value="Pedestrian Accident">
                                Pedestrian Accident
                            </option>

                            <option value="Bicycle Accidents">
                                Bicycle Accidents
                            </option>

                            <option value="Spinal Injury">
                                Spinal Injury
                            </option>

                            <option value="Motorcycle Accident">
                                Motorcycle Accident
                            </option>

                            <option value="Whiplash Injury">
                                Whiplash Injury
                            </option>

                            <option value="Drunk Driving">
                                Drunk Driving
                            </option>

                            <option value="Truck Accident">
                                Truck Accident
                            </option>

                            <option value="Head-On Collision">
                                Head-On Collision
                            </option>
                        </select>

                        {errors.injuryType && (
                            <small className="error">
                                {errors.injuryType}
                            </small>
                        )}
                    </div>


                    {/* Brief Description */}
                    <div className="form-group" style={{marginBottom:'0'}}>
                        <label>Brief Description</label>

                        <textarea
                            rows="3"
                            name="briefDescription"
                            placeholder="Briefly describe your situation…"
                            value={formData.briefDescription}
                            onChange={handleChange}
                        />

                        {errors.description && (
                            <small className="error">
                                {errors.description}
                            </small>
                        )}
                    </div>


                    {/* Privacy Policy */}
                    <div className="form-consent" style={{marginBottom:0}}>

                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                name="privacyPolicy"
                                checked={formData.privacyPolicy}
                                onChange={handleChange}
                            />

                            <span>
                                I read the{" "}
                                <a
                                    href="/privacy-policy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Privacy Policy
                                </a>
                            </span>
                        </label>

                        {errors.privacyPolicy && (
                            <small className="error consent-error" style={{display: 'block'}}>
                                {errors.privacyPolicy}
                            </small>
                        )}

                    </div>


                    {/* Terms & Conditions */}
                    <div className="form-consent">

                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                name="termsConditions"
                                checked={formData.termsConditions}
                                onChange={handleChange}
                            />

                            <span>
                                I agree to the{" "}
                                <a
                                    href="/terms-and-conditions"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Terms and Conditions
                                </a>
                            </span>
                        </label>

                        {errors.termsConditions && (
                            <small className="error consent-error" style={{display: 'block'}}>
                                {errors.termsConditions}
                            </small>
                        )}

                    </div>


                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="form-submit"
                        disabled={submitLoader}
                    >
                        {submitLoader ? (
                            <FontAwesomeIcon
                                icon={faSpinner}
                                className="spinner-icon"
                                spin
                                style={{
                                    fontSize: "20px",
                                    color: "#0f0f0e",
                                    marginRight: "10px"
                                }}
                            />
                        ) : null}

                        Request Consultation
                    </button>

                </form>


                {/* Bottom Form Checks */}
                <div className="form-checks">

                    <div className="form-check-item">
                        <svg
                            width="14"
                            height="14"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="10"
                            />

                            <path d="m9 12 2 2 4-4" />
                        </svg>

                        No Upfront Fees
                    </div>


                    <div className="form-check-item">
                        <svg
                            width="14"
                            height="14"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="10"
                            />

                            <path d="m9 12 2 2 4-4" />
                        </svg>

                        Confidential
                    </div>


                    <div className="form-check-item">
                        <svg
                            width="14"
                            height="14"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="10"
                            />

                            <path d="m9 12 2 2 4-4" />
                        </svg>

                        Responsive Guidance
                    </div>


                    <div className="form-check-item">
                        <svg
                            width="14"
                            height="14"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="10"
                            />

                            <path d="m9 12 2 2 4-4" />
                        </svg>

                        Focused Rep.
                    </div>

                </div>

            </div>


            {/* Success / Error Dialog */}
            {resultDialog ? (
                <SuccessErrorDialog
                    type={type}
                    message={message}
                    open={resultDialog}
                    handleClose={() => setResultDialog(false)}
                />
            ) : null}

        </>
    );
};

export default ReviewForm;
